export const isPaddedUcdLogo = (url) => /\/university-college-dublin\/logo\.png(?:\?|$)/i.test(String(url || ''));
